<template>
  <div class="third faqConfig">
    <div class="third-formOne">
      <div class="formOne-btn">
        <div class="btn-left">
          <span class="left-back-icon" @click="changeComponent">
            <i class="el-icon-arrow-left"></i>
            <span class="left-back-title">返回</span>
          </span>
          <span class="left-back-shu">
            <span class="left-back-shu-content"></span>
          </span>
          <span class="left-back-content">{{ headerName }}</span>
        </div>
        <div class="btn-right">
          <el-button
            v-el-disabel-repeat-click
            @click="submitForm('faqForm')"
            class="btn-two"
            type="primary"
          >保存</el-button>
          <el-button v-el-disabel-repeat-click @click="Reset" class="btn-two" type="default">重置</el-button>
        </div>
      </div>
      <div class="third-one library">
        <div class="formOne-forms">
          <el-form
            :inline="false"
            :model="faqForm"
            ref="faqForm"
            :rules="faqFormRules"
            label-width="120px"
            @validate="validateTwo"
            :show-message="false"
          >
            <div class="forms-one" style="margin-top: 57px;">
              <div class="one-title">
                <div class="title-left">
                  <span class="left-icon">
                    <i class="el-icon-s-operation"></i>
                  </span>
                  <span class="left-content">基本信息</span>
                </div>
              </div>
              <div>
                <div class="one-list">
                  <div class="list-one-line">
                    <el-form-item label="问题名称" prop="titleName">
                      <el-input
                        class="list-input"
                        :maxlength="200"
                        v-model.trim="faqForm.titleName"
                        placeholder="请输入"
                      ></el-input>
                    </el-form-item>
                  </div>
                </div>
                <div class="one-list">
                  <div class="list-one-line">
                    <el-form-item label="问题分类" prop="type">
                      <el-select
                        class="item-input"
                        v-model="faqForm.type"
                        placeholder="请选择"
                        style="width:293px;"
                      >
                        <el-option
                          v-for="item in faqTypeList"
                          :key="item.index"
                          :label="item.typeName"
                          :value="item.questionType"
                        ></el-option>
                      </el-select>
                    </el-form-item>
                  </div>
                </div>
                <div class="one-list">
                  <div class="list-one-line">
                    <el-form-item label="答案类型" prop="faqType">
                      <el-radio-group @change="typeChange" v-model="faqForm.faqType">
                        <el-radio :label="1">文本</el-radio>
                        <el-radio :label="2">链接</el-radio>
                      </el-radio-group>
                    </el-form-item>
                  </div>
                </div>
                <div class="one-list">
                  <div class="list-one-line">
                    <el-form-item v-if="faqForm.faqType == 1" label="答案" prop="faqAnswer">
                      <el-input

                        class="list-textarea faqConfig-list-textarea"
                        type="textarea"
                        placeholder="请输入答案（文本）"
                        maxlength="10000"
                        v-model="faqForm.faqAnswer"
                      ></el-input>
                    </el-form-item>
                    <el-form-item v-if="faqForm.faqType == 2" label="答案" prop="faqAnswer"
                      :rules="[
                        { required: true, message: '请输入答案', trigger: 'blur' },
                        { type: 'string', pattern: /^http[s]?:\/\/.*/, message:'请完整输入http(s)', trigger: 'blur'}
                      ]"
                    >
                      <el-input
                        maxlength="1000"
                        class="list-input"
                        placeholder="请输入访问链接"
                        v-model.trim="faqForm.faqAnswer"
                      ></el-input>
                    </el-form-item>
                  </div>
                </div>
              </div>
            </div>
            <div class="forms-one">
              <div class="one-title">
                <div class="title-left">
                  <span class="left-icon">
                    <i class="el-icon-s-operation"></i>
                  </span>
                  <span class="left-content">首页展示</span>
                </div>
              </div>
              <div>
                <div class="one-list">
                  <div class="list-one-line">
                    <el-form-item label="是否为常见问题" prop="isDisplay">
                      <el-radio-group v-model="faqForm.isDisplay">
                        <el-radio :label="1">是
                          <el-tooltip
                            class="item"
                            effect="dark"
                            content="此问题将推荐至机器人问答会话首页，用户打开机器人即可查看"
                            placement="top-start"
                          >
                            <div style="display: inline-block;">
                              <img style='width: 14px;margin-bottom: -3px;' src="@/assets/question.png" alt="">
                            </div>
                          </el-tooltip>
                        </el-radio>
                        <el-radio :label="0">否
                          <el-tooltip
                            class="item"
                            effect="dark"
                            content="此问题需用户输入关键词或进入全部问题列表才可查看"
                            placement="top-start"
                          >
                            <div style="display: inline-block;">
                              <img style='width: 14px;margin-bottom: -3px;' src="@/assets/question.png" alt="">
                            </div>
                          </el-tooltip>
                        </el-radio>
                      </el-radio-group>
                    </el-form-item>
                  </div>
                </div>
                <div class="one-list">
                  <div class="list-one-line">
                    <el-form-item label="展示顺序" prop="order">
                      <el-input-number
                        class="list-input"
                        v-model="faqForm.order"
                        :min="1"
                        :max="99"
                        step-strictly
                        placeholder="请输入数字"
                        :controls="false"
                      ></el-input-number>
                    </el-form-item>
                  </div>
                </div>
              </div>
            </div>
          </el-form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { removeStore, getStore } from "@/utils/store";
import { mapActions, mapState, mapMutations } from "vuex";
import { cloneDeep } from "lodash";
import { encrypt } from "@/utils/encrypt";
export default {
  name: "faqConfig",
  props: {
    enterFAQ: Object
  },
  data() {
    return {
      headerName: "",
      faqForm: {
        id: "",
        titleName: "",
        type: "",
        faqType: 1,
        faqAnswer: "",
        isDisplay: "",
        order: undefined
      },
      faqFormRules: {
        titleName: [{ required: true, message: "请输入问题名称", trigger: "blur" }],
        type: [
          { required: true, message: "请选择问题分类", trigger: "change" }
        ],
        faqType: [
          { required: true, message: "请选择答案类型", trigger: "change" }
        ],
        faqAnswer: [{ required: true, message: "请输入回答", trigger: "blur" }],
        isDisplay: [
          { required: true, message: "请选择是否为常见问题", trigger: "change" }
        ],
        order: [
          { required: true, message: "请输入展示顺序", trigger: "change" }
        ]
      },
      countNum: 1,
      faqTypeList: []
    };
  },
  computed: {
    ...mapState({
      userInfo: state => state.user.userInfo,
      componentsName: state =>
        state.robotsManage.robotsManage_faqLibrary_ComponentName
    })
  },
  created() {
    if (this.enterFAQ) {
      this.headerName = "编辑问题";
      this.faqForm.id = this.enterFAQ.questionId;
      this.faqForm.titleName = this.enterFAQ.questionName;
      this.faqForm.type = this.enterFAQ.questionType;
      this.faqForm.faqType = this.enterFAQ.answerType;
      this.faqForm.faqAnswer = this.enterFAQ.answer;
      this.faqForm.isDisplay = this.enterFAQ.isShow;
      this.faqForm.order = this.enterFAQ.sort;
    } else {
      this.headerName = "新建问题";
      if (sessionStorage.getItem('apiServerDataBaseId')) {
        console.log(sessionStorage.getItem('apiServerDataBaseId'))
        this.faqForm.type = sessionStorage.getItem('apiServerDataBaseId') && sessionStorage.getItem('apiServerDataBaseId') !== 'undefined' ? sessionStorage.getItem('apiServerDataBaseId') : ''
      }
      console.log(this.faqForm, '问题')
    }
    this.faqTypeList = getStore({
      name: "saveFAQTypeList",
      type: "session"
    });
  },
  methods: {
    ...mapActions(["saveFAQ"]),
    ...mapMutations({
      changeComponentName: "SET_robotsManage_faqLibrary_ComponentName"
    }),
    typeChange () {
      this.faqForm.faqAnswer = ''
    },
    // 验证
    validateTwo(prop, msgStatus, validateMessage) {
      // console.log(prop, msgStatus, validateMessage)
      if (!msgStatus && !this.countNum) {
        this.countNum += 1;
        if (validateMessage) {
          this.$message.error(validateMessage);
        }
      }
    },
    //表单验证
    submitForm(formName) {
      this.countNum = 0;
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.countNum = 1
          this.saveFAQFuc();
        } else {
          return false;
        }
      });
    },
    Reset() {
      this.$refs["faqForm"].resetFields();
      this.faqForm.id = this.enterFAQ.questionId;
      this.faqForm.titleName = this.enterFAQ.questionName;
      this.faqForm.type = this.enterFAQ.questionType;
      this.faqForm.faqType = this.enterFAQ.answerType;
      this.faqForm.faqAnswer = this.enterFAQ.answer;
      this.faqForm.isDisplay = this.enterFAQ.isShow;
      this.faqForm.order = this.enterFAQ.sort;
    },
    // 获取处理机制数据
    async saveFAQFuc() {
      const {
        data: { msg, status }
      } = await this.saveFAQ({
        questionId: this.faqForm.id,
        questionName: this.faqForm.titleName,
        questionType: this.faqForm.type,
        answerType: this.faqForm.faqType,
        answer: this.faqForm.faqAnswer,
        isShow: this.faqForm.isDisplay,
        sort: this.faqForm.order
      });
      if (status === 1000) {
        this.$message.success("操作成功");
        setTimeout(() => {
          this.changeComponent();
        }, 1000);
        return;
      }
      this.$message.error(msg);
    },
    // 改变index页面的component的值
    changeComponent() {
      removeStore({
        name: "FaqConfig",
        type: "session"
      });
      removeStore({
        name: "saveFAQTypeList",
        type: "session"
      });
      this.changeComponentName("BasicPage");
    }
  }
};
</script>

<style lang="scss">
.faqConfig {
  min-height: 100vh;
  .faqConfig-list-textarea {
    textarea {
      resize: both !important;
    }
  }
  .third-formOne {
    height: 100vh;
  }
  .el-table__body-wrapper {
    height: calc(100vh - 210px) !important;
  }
  .el-form-item__label {
    padding-right: 10px;
  }
  .el-input-number.is-without-controls .el-input__inner {
    text-align: left;
  }
}
</style>
